// Popover behavior for the calendar legend: trigger toggle, outside-click and Escape close.
import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["trigger", "popover"]

  triggerTarget: HTMLButtonElement
  popoverTarget: HTMLElement

  toggle() {
    this.popoverTarget.hidden ? this.open() : this.close()
  }

  open() {
    this.popoverTarget.hidden = false
    this.triggerTarget.setAttribute("aria-expanded", "true")
  }

  close() {
    this.popoverTarget.hidden = true
    this.triggerTarget.setAttribute("aria-expanded", "false")
  }

  closeOnOutsideClick(event: Event) {
    if (this.popoverTarget.hidden) return
    if (this.element.contains(event.target as Node)) return

    this.close()
  }

  closeOnEscape(event: KeyboardEvent) {
    if (event.key === "Escape") this.close()
  }
}
